export const STATE = {
  1: 'Activo',
  0: 'Inactivo'
};
